/**
 * /frontend/src/features/analytics/api/peakAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches peak heatmap matrix.
 */
export const getPeakHeatmap = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.PEAK_HEATMAP,
  { storeId, startDate, endDate },
  token,
  'analytics-peak-heatmap'
);

/**
 * Fetches top peak hours for the last N weeks.
 */
export const getPeakTopHours = async (request, token, storeId, weeks) => getJson(
  request,
  ANALYTICS_ENDPOINTS.PEAK_TOP_HOURS,
  { storeId, weeks },
  token,
  'analytics-peak-top-hours'
);

/**
 * Fetches day comparison for a date.
 */
export const getPeakDayComparison = async (request, token, storeId, date) => getJson(
  request,
  ANALYTICS_ENDPOINTS.PEAK_DAY_COMPARISON,
  { storeId, date },
  token,
  'analytics-peak-day-comparison'
);

